import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SubmitButton from "../../common/button/SubmitButtton";
import { allowOnlyNumbers } from "../../../utiles/helpers";

const VerifyOTP = () => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const Logo = process.env.REACT_APP_LOGO_URL;
  
  const handleVerify = (e) => {
    e.preventDefault();
    setError("");

    if (!otp || otp.length !== 6) {
      return setError("Enter a valid 6-digit OTP.");
    }

    if (otp === "123456") {
      navigate("/reset-password");
    } else {
      setError("Invalid OTP.");
    }
  };

  return (
    <div>
      <div className="wrapper">
        <div className="section-authentication-cover">
          <div className="">
            <div className="row g-0">
              <div className="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex">
                <div className="card shadow-none bg-transparent shadow-none rounded-0 mb-0">
                  <div className="card-body">
                    <img
                      src="/assets/images/v1/login-image/bankImg.png"
                      className="img-fluid"
                      width="600"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center">
                <div className="card rounded-0 m-3 shadow-none bg-transparent mb-0">
                  <div className="card-body p-sm-5">
                    <div className="p-3 text-center">
                      <div className="text-center">
                        <img src={Logo} width="60" alt="" />
                      </div>
                      <h4 className="text-center mt-4 font-weight-bold">
                        OTP  Verification
                      </h4>
                      <p className="text-center text-muted">
                      One Time Password (OTP) has been sent successfully to
                      email <b>{localStorage.getItem("ForgetEmail")}</b>
                      </p>

                      <form onSubmit={handleVerify} className="row g-3">
                        <div className="col-12 ">
                          <label
                            htmlFor="otp"
                            className="form-label  text-left"
                          >
                            OTP<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            maxLength={6}
                            className="form-control"
                              value={otp}
                            onChange={(e) => {
                              setError("");
                              setOtp(allowOnlyNumbers(e.target.value));
                            }}
                          />
                          {error && (
                            <p className="text-danger pt-2 text-left mb-0">
                              {error}
                            </p>
                          )}
                        </div>
                        <SubmitButton label="  Send Reset Link" />
                        <div className="d-grid mt-3">
                          <a href="/login" className="btn btn-light">
                            Back To Login
                          </a>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOTP;
